export default "__VITE_ASSET__CV8obUfl__"